const activeProducerByPeerMedia = new Map();
const stoppedProducerIds = new Set();

function getProducerKey(peerId, mediaType) {
  return `${peerId}:${mediaType}`;
}

export function markProducerStarted(peerId, mediaType, producerId) {
  if (!peerId || !mediaType || !producerId) {
    return;
  }

  const key = getProducerKey(peerId, mediaType);

  activeProducerByPeerMedia.set(key, producerId);
  stoppedProducerIds.delete(producerId);
}

export function markProducerStopped(peerId, mediaType, producerId) {
  if (!peerId || !mediaType || !producerId) {
    return;
  }

  const key = getProducerKey(peerId, mediaType);
  const activeProducerId = activeProducerByPeerMedia.get(key);

  stoppedProducerIds.add(producerId);

  if (activeProducerId === producerId) {
    activeProducerByPeerMedia.delete(key);
  }
}

export function isProducerActual(peerId, mediaType, producerId) {
  if (!peerId || !mediaType || !producerId) {
    return false;
  }

  const key = getProducerKey(peerId, mediaType);
  const activeProducerId = activeProducerByPeerMedia.get(key);

  return activeProducerId === producerId && !stoppedProducerIds.has(producerId);
}

export function isStopEventActual(peerId, mediaType, producerId) {
  if (!peerId || !mediaType || !producerId) {
    return false;
  }

  const key = getProducerKey(peerId, mediaType);
  const activeProducerId = activeProducerByPeerMedia.get(key);

  return activeProducerId === producerId || !activeProducerId;
}
